import styled, { css } from "styled-components";
import React, { forwardRef } from "react";

import { TextLabel, TextNote1 } from "..";
import { colors } from "common/const/colors";
import { IconWrapper, InfoIcon, WarningIcon } from "../icon";

export const InputLayout = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  gap: 0.75rem;
`;

export const InputContainer = styled.div`
  display: flex;
  flex-direction: ${({ $direction }) => $direction};
  align-items: ${({ $direction }) =>
    $direction === "row" ? "center" : "initial"};
  position: relative;
  width: 100%;
  height: 100%;
`;

const InputIconWrapper = styled.div`
  position: absolute;
  width: 1.5rem;
  height: 1.5rem;
  ${({ position }) =>
    position === "right" ? "right: 1.25rem;" : "left: 1.25rem;"}
  top: 50%;
  transform: translateY(-50%);
  overflow: hidden;

  & > * {
    width: 100%;
    height: 100%;
  }
`;

export const CaptionContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.25rem;
`;

export const inputBorderStyle = css`
  outline: none;
  border: var(--border-width) solid;
  border-radius: var(--border-radius-8);
  border-color: ${({ $error }) => ($error ? colors.Red : colors.Gray)};

  &::placeholder {
    color: var(--LightNavy);
  }

  &:focus {
    border-color: ${({ $error }) => ($error ? colors.Red : colors.MainBlue)};
  }

  &:disabled {
    background-color: var(--LightGray);
  }

  &:read-only {
    background-color: var(--LightGray);
    &:focus,
    &:focus-within {
      border-color: var(--Gray);
    }
  }
`;

export const InputWrapper = forwardRef((props, ref) => {
  const { label, caption, icon, rules, direction, error, children, ...rest } =
    props;
  const IconElement = icon?.element;

  return (
    <InputLayout {...rest}>
      {label &&
        (typeof label === "string" ? (
          <TextLabel>
            {label}
            {rules?.required && <span style={{ color: colors.Red }}> *</span>}
          </TextLabel>
        ) : (
          label
        ))}

      <InputContainer $direction={direction} ref={ref}>
        {IconElement && (
          <InputIconWrapper position={icon.position}>
            {IconElement}
          </InputIconWrapper>
        )}
        {children}
      </InputContainer>

      {caption &&
        (typeof caption === "string" ? (
          <CaptionContainer>
            <IconWrapper size="1rem">
              {!!error ? <WarningIcon color={colors.Red} /> : <InfoIcon />}
            </IconWrapper>
            <TextNote1 style={{ color: !!error ? colors.Red : "inherit" }}>
              {error?.message || caption}
            </TextNote1>
          </CaptionContainer>
        ) : (
          caption
        ))}
    </InputLayout>
  );
});
